import React from "react";
import { Navigate } from "react-router-dom";
import { useEntitlement } from "../lib/useEntitlement";

// Keep saved links from mounting a paid screen or fetching its configuration
// before the current workspace's entitlement is known.
export default function RequireFeature({ feature, children }) {
  const { loading, error, hasFeature } = useEntitlement();
  if (loading) return <p role="status" className="p-6">Checking plan access…</p>;
  if (error?.status === 401) return <Navigate to="/agent/login" replace />;
  if (error?.status === 403) return <Navigate to="/agent" replace />;
  if (error) return <p role="alert" className="p-6">Plan access could not be checked. Refresh the page to try again.</p>;
  if (!hasFeature(feature)) return <Navigate to="/admin/routing" replace />;
  return children;
}
